// @ts-ignore
/* eslint-disable */
import request from "@/request";

/** 获取平台统计概览（题目总数、提交总数、用户总数） GET /stats/overview */
export async function getOverview(options?: { [key: string]: any }) {
  return request<API.BaseResponseStatsOverviewVO>("/stats/overview", {
    method: "GET",
    ...(options || {}),
  });
}
